var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"body"},[_c('div',[_c('themed-table',{attrs:{"headers":this.transformedHeaders,"data":_vm.transformedData,"pagination":{
            perPage: this.bedManagerService.devices.query.limit,
            total: this.bedManagerService.devices.total
        },"sortingEnabled":true,"filteringEnabled":false,"paginationEnabled":this.bedManagerService.devices.total > this.bedManagerService.devices.query.limit,"tenantSelected":_vm.currentTenant,"tenantOptions":this.bedManagerService.tenants.data,"syncSearchValues":_vm.currentQuery,"locationTreeSearchValue":this.bedManagerService.devices.searchValue,"addItem":{ label: 'Job', element: _vm.CreateJobs }},on:{"paginationChange":(event) => {
            this.bedManagerService.devices.query.skip = this.bedManagerService.devices.query.limit * (event.page - 1);
            this.bedManagerService.devices.query = {...this.bedManagerService.devices.query};
        },"areasChange":(event) => {
            this.bedManagerService.devices.searchValue = '';
            this.bedManagerService.devices.query.area = event;
            this.bedManagerService.devices.query = {...this.bedManagerService.devices.query};
            const item = this.bedManagerService.devices.headers.find((header) => header.key === 'poc');
            if (item && event && event.length) {
              item.filterActive = true;
            } else if (item) item.filterActive = false;
            this.bedManagerService.devices.headers = [...this.bedManagerService.devices.headers];
        },"locationTreeSearch":(event) => {
            this.bedManagerService.devices.searchValue = event;
        },"searchChange":(event) => {
          const query = this.bedManagerService.devices.query;
          query.skip = 0; // Resets skip as the search params change
          let newTenant = null;
          Object.keys(event).forEach((key) => {
            const customHandlers = ['scope', 'deviceCount'];
              if (!customHandlers.includes(key) && event[key]) query[key] = event[key];
              else if (key === 'scope' && event[key] && this.bedManagerService.tenants.selected !== event[key]) newTenant = event[key];
              else if (key === 'deviceCount' && event[key]) query['deviceId'] = event[key];
              else delete query[key];
          })
          if (newTenant !== null) {
            Object.keys(query).forEach((prop) => this.bedManagerService.devices.query[prop] = query[prop]);
            this.bedManagerService.tenants.selected = newTenant;
            if (!newTenant) {
              this.bedManagerService.devices.data = [];
              this.bedManagerService.devices.total = 0;
              this.bedManagerService.jobs.data = [];
              this.bedManagerService.jobs.total = 0;
            }
          } else {
            this.bedManagerService.devices.query = {...query};
          }
        },"tenantChange":(event) => {
          this.bedManagerService.tenants.selected = event;
          if (!event) {
            this.bedManagerService.devices.data = [];
            this.bedManagerService.devices.total = 0;
            this.bedManagerService.jobs.data = [];
            this.bedManagerService.jobs.total = 0;
          }
        },"sortingChange":(event) => {
          if (event.type === 'firmwareVersionFormatted') {
            this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query, sortProperty: 'firmwareVersion', sortDirection: event.direction };
          } else if (event.type === 'status') {
            this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query, sortProperty: 'isOffline', sortDirection: event.direction };
          } else if (event.type === 'serial') {
            this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query, sortProperty: 'properties.bedData.PropertiesResponse.GatewayMACAddress', sortDirection: event.direction };
          } else {
            this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query, sortProperty: event.type, sortDirection: event.direction };
          }
        },"rowClick":(event) => {
          _vm.setDevice(event);
        }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }